import React, { FC, useContext } from 'react';
import { TopPerformingBrokers } from './components/TopPerformingBrokers';
import SummaryCard from './components/SummaryCard';
import ActiveLeadsCard from './components/ActiveLeadsCard';
import DealByStatusCard from './components/DealByStatusCard';
import EnterpriseNavigation from '../../components/EnterpriseNavigation';
import EnterpriseContext from '../../providers/Enterprise/Enterprise.context';
import EnterpriseSuggestedActions from 'components/EnterpriseSuggestedActions';
import CurrentUserContext from 'providers/CurrentUser/CurrentUser.context';
import { useLockScrollOnParamsReroute } from 'hooks/useLockScrollOnParamsReroute';
import ExportUsageReportModal from './components/ExportUsageReportModal';

import './Analytics.styles.scss';
import './Analytics.styles.responsive.scss';

const Analytics: FC = () => {
  const { isOfficeManager, isRegularEnterpriseMember } =
    useContext(CurrentUserContext);
  const { enterprise } = useContext(EnterpriseContext);

  // Regular members only get the summarized overview and have no other
  // enterprise pages, so they see no subnav. Office managers get the same
  // summarized cards but keep the subnav to reach their other pages. Enterprise
  // heads (and super admins) get the full analytics overview.
  const showNavigation = !isRegularEnterpriseMember;
  const showFullOverview = !isRegularEnterpriseMember && !isOfficeManager;

  useLockScrollOnParamsReroute();

  return (
    <div className="enterprise-analytics">
      {showNavigation && (
        <div className="enterprise-analytics__navigation-row">
          <EnterpriseNavigation />
          <ExportUsageReportModal enterprise={enterprise} />
        </div>
      )}

      <div className="enterprise-analytics__cards">
        {showFullOverview && (
          <>
            <SummaryCard />
            <TopPerformingBrokers />
          </>
        )}
        <DealByStatusCard />
        <ActiveLeadsCard />
      </div>

      <EnterpriseSuggestedActions enterpriseId={enterprise?._id} />
    </div>
  );
};

export default Analytics;
